import namespace from "@rdfjs/namespace";
export const wgs = namespace("http://www.w3.org/2003/01/geo/wgs84_pos#");
